/**
 * Copyright © 2026 Adnuntius AS.
 */
import {Component, Input} from '@angular/core';
import {BlocklistListPageComponent} from './blocklist-list-page.component';

@Component({
  standalone: true,
  imports: [BlocklistListPageComponent],
  selector: 'adn-blocklist-route-page',
  template: `
    <adn-blocklist-list-page [readOnly]="readOnly"></adn-blocklist-list-page>
  `
})
export class BlocklistRoutePageComponent {
  @Input() readOnly = false;
}
